var _path, _path2, _path3, _path4, _g, _path5, _path6, _g2, _path7, _path8, _g3, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacadeTotalLook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 96,
    viewBox: "0 0 231 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.045 6.5L203.269 94.5554H170.548L178.692 6.5H217.045Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.096 80.1562L218.71 6.49999H220.483L229.887 94.5553H212.608L208.096 80.1562Z",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_597:6139",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 170,
    y: 6,
    width: 61,
    height: 90
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.236 6L170 95.0554H203.697L217.629 6H178.236Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.933 5.99999H218.277L207.584 80.1974L212.241 95.0553H230.443L220.933 5.99999Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_597:6139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.066 2.0595C172.29 8.21613 182.738 23.5026 182.738 35.3954C182.738 47.2882 165.925 32.7826 157.519 24.0432",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.077 117.122C188.255 93.4791 178.404 62.7432 181.95 50.9217C185.497 39.1002 188.649 88.7505 167.371 56.8325",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.896 112.423C219.896 99.813 220.685 75.9335 223.837 81.2926C227.777 87.9915 229.748 110.846 235.658 112.423",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.616,
    cy: 84.416,
    r: 3.04645,
    stroke: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.333 102.23C201.105 97.0457 242.902 28.8549 207.585 79.8733M216.333 3.08392C201.753 3.08392 200.001 30.8611 195.273 39.3726C189.362 50.0119 182.208 12.6198 190.089 -2.74818",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.328 99.6377C188.468 70.1532 211.473 57.841 201.104 48.1208C189.602 37.3371 193.328 76.9573 231.207 28.4609",
    stroke: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122 42.4V51.7333",
    stroke: "white",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.4 47H126.733",
    stroke: "white",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_597:6139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7237 17H27.8007L10 35.2754L20.5362 43.8707L29.9722 38.0261L24.6649 77H67.0845L63.608 60.1278L35.7237 17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7266 17H53.7932L44.9189 28.5264L63 58L59.5551 38.0261L68.9912 43.8707L79.5273 35.2754L61.7266 17Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_597:6139",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 17,
    width: 70,
    height: 60
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7237 17H27.8007L10 35.2754L20.5362 43.8707L29.9722 38.0261L24.6649 77H67.0845L63.608 60.1278L35.7237 17Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7266 17H53.7932L44.9189 28.5264L62.587 55.015L59.5551 38.0261L68.9912 43.8707L79.5273 35.2754L61.7266 17Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_597:6139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8891 11.4605C19.5654 18.2002 13.5828 36.8867 16.2417 57.7151",
    stroke: "#F59CB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8751 11.4605C25.1053 14.8765 20.3968 27.0818 23.7205 48.575C27.8751 75.4415 8.76378 78.7652 7.37891 80.427",
    stroke: "#F59CB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.86 11.7375C30.1826 14.5996 26.4342 24.2567 32.86 39.9888C40.8923 59.654 35.6297 82.9198 30.3672 87.6283",
    stroke: "#F59CB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6769 12.0145C35.7225 15.7075 32.4173 26.3617 42.8315 39.4349C55.8493 55.7763 55.8492 72.3948 54.7413 83.1968",
    stroke: "#F59CB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4345 13.229C46.9573 18.3991 46.5511 29.2934 56.7437 31.5092C69.4845 34.279 79.7325 33.448 83.8871 46.4658",
    stroke: "#F59CB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6699 11.077C49.2083 16.6164 52.5504 27.363 69.612 26.0336",
    stroke: "#F59CB8"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85356 11.2426L11.9181 6.17813C13.1625 4.93374 13.3461 2.88651 12.1684 1.57874C11.8735 1.25022 11.5146 0.985242 11.1139 0.799977C10.7131 0.614712 10.2788 0.513043 9.83744 0.501175C9.39609 0.489306 8.95694 0.567486 8.5468 0.730945C8.13665 0.894404 7.76411 1.13971 7.45191 1.45191L6.5 2.40381L5.67813 1.58194C4.43374 0.337534 2.38651 0.153942 1.07874 1.33157C0.750219 1.62654 0.485242 1.98536 0.299977 2.38613C0.114712 2.78689 0.0130433 3.2212 0.00117461 3.66256C-0.0106941 4.10392 0.067486 4.54307 0.230945 4.95321C0.394404 5.36335 0.639713 5.73589 0.951907 6.0481L6.14645 11.2426C6.24022 11.3364 6.36739 11.3891 6.5 11.3891C6.63261 11.3891 6.75979 11.3364 6.85356 11.2426Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_597:6139",
    x: 6,
    y: 13,
    width: 77.5273,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_597:6139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_597:6139",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacadeTotalLook);
export default __webpack_public_path__ + "static/media/facade-total-look.acb495d1.svg";
export { ForwardRef as ReactComponent };